export default function Oven(props: any) {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.495 25.3745H6.50499C5.81182 25.3745 5.25 24.7539 5.25 23.9881V4.01089C5.25 3.24515 5.81182 2.62451 6.50499 2.62451H21.495C22.1882 2.62451 22.75 3.24515 22.75 4.01089V23.9881C22.75 24.7539 22.1882 25.3745 21.495 25.3745Z"
                stroke="#757575"
                strokeWidth="1.05"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M5.25 7.87451L22.75 7.87451" stroke="#757575" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.328 21.8745H8.67201C8.23206 21.8745 7.875 21.5022 7.875 21.0424V13.9566C7.875 13.4969 8.23206 13.1245 8.67201 13.1245H19.328C19.7679 13.1245 20.125 13.4969 20.125 13.9566V21.0424C20.125 21.5022 19.7679 21.8745 19.328 21.8745Z"
                stroke="#757575"
                strokeWidth="1.05"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.375 5.92174H16.3791V4.37451H11.375V5.92174Z"
                stroke="#757575"
                strokeWidth="1.05"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M7.875 10.4995H20.125" stroke="#757575" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.875 25.812C7.875 26.0536 8.07088 26.2495 8.3125 26.2495H9.1875C9.42912 26.2495 9.625 26.0536 9.625 25.812V25.812C9.625 25.5704 9.42912 25.3745 9.1875 25.3745H8.3125C8.07088 25.3745 7.875 25.5704 7.875 25.812V25.812Z"
                stroke="#757575"
                strokeWidth="1.05"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.375 25.812C18.375 26.0536 18.5709 26.2495 18.8125 26.2495H19.6875C19.9291 26.2495 20.125 26.0536 20.125 25.812V25.812C20.125 25.5704 19.9291 25.3745 19.6875 25.3745H18.8125C18.5709 25.3745 18.375 25.5704 18.375 25.812V25.812Z"
                stroke="#757575"
                strokeWidth="1.05"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
